import { render, staticRenderFns } from "./TabEvaluationAssessment.vue?vue&type=template&id=db88624e&scoped=true&"
import script from "./TabEvaluationAssessment.vue?vue&type=script&lang=js&"
export * from "./TabEvaluationAssessment.vue?vue&type=script&lang=js&"
import style0 from "./TabEvaluationAssessment.vue?vue&type=style&index=0&id=db88624e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db88624e",
  null
  
)

export default component.exports